"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cards = void 0;
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
var Cards = function (_a) {
    var channel = _a.channel, user = _a.user;
    var _b = storybook_1.Hooks.useModal(), Modal = _b[0], setModal = _b[1];
    var _c = ra_fetch_1.useApi('ecommerce').index('vouchers', { channel_id: channel.id, parent_id: 'null' }), vouchers = _c[0], setVouchers = _c[1];
    var destroy = function (voucher) {
        ra_fetch_1.Fetcher.api('ecommerce')
            .records(vouchers.data)
            .delete('vouchers', { id: voucher.id, channel_id: channel.id })
            .then(function (response) {
            if (response.errors.length) {
                return;
            }
            setVouchers(response.records);
        });
    };
    if (vouchers.loading) {
        return react_1.default.createElement(storybook_1.Icons.Icon, { name: 'loader' });
    }
    if (!vouchers.data.length) {
        return react_1.default.createElement(storybook_1.Forms.New, { description: 'Je hebt nog geen vouchers', label: 'Nieuwe voucher', to: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/vouchers/create", icon: 'plus' });
    }
    return react_1.default.createElement(storybook_1.Grids.List, null,
        react_1.default.createElement(Modal, null),
        vouchers.data.map(function (voucher) { return react_1.default.createElement(storybook_1.Vouchers.Card, { key: voucher.id, voucher: voucher, destroy: destroy, user: user, onDelete: function (voucher) { return setModal({
                content: function () { return react_1.default.createElement(storybook_1.Forms.DeleteModal, { title: 'voucher', route: 'vouchers', api: 'ecommerce', params: { id: voucher.id, channel_id: channel.id } }); }
            }); }, onShare: function () { return setModal({
                content: function () { return react_1.default.createElement(storybook_1.Vouchers.Share, { voucher: voucher }); }
            }); } }); }));
};
exports.Cards = Cards;
